var map = {
	"./01-01.mp3": 487,
	"./01-01__.mp3": 761,
	"./01-02.mp3": 762,
	"./01-03.mp3": 353,
	"./01-04.mp3": 354,
	"./01-05.mp3": 488,
	"./01-06.mp3": 763,
	"./01-07.mp3": 764,
	"./01-08.mp3": 765,
	"./01-09.mp3": 766,
	"./01-10.mp3": 767,
	"./01-11.mp3": 805,
	"./01-12.mp3": 1521,
	"./01-13.mp3": 1522,
	"./01-14.mp3": 806,
	"./04-01.mp3": 1523,
	"./04-02.mp3": 1524,
	"./04-03.mp3": 807,
	"./04.mp3": 1525,
	"./emotion-slow.mp3": 808,
	"./emotion.mp3": 1526,
	"./ex1-slow.mp3": 809,
	"./ex1.mp3": 1527,
	"./ex1_3_4-slow.mp3": 810,
	"./ex1_3_4.mp3": 1528,
	"./ex7-slow.mp3": 811,
	"./ex7.mp3": 1529,
	"./ex8-slow.mp3": 812,
	"./ex8.mp3": 1530,
	"./health-slow.mp3": 813,
	"./health.mp3": 1531,
	"./intoSleep.mp3": 496,
	"./life-cycle-slow.mp3": 814,
	"./life-cycle.mp3": 1532,
	"./life-slow.mp3": 815,
	"./life.mp3": 1533,
	"./natureFeedback.mp3": 1534,
	"./natureFeedbackEffect.mp3": 816,
	"./recognition-slow.mp3": 817,
	"./recognition.mp3": 1535,
	"./soundAlpha.mp3": 1536,
	"./soundAlpha1.mp3": 1537,
	"./soundAlpha2.mp3": 1538,
	"./soundAttemption.mp3": 768,
	"./soundAttemptionNew.mp3": 1539,
	"./soundBalance.mp3": 770,
	"./soundBalanceF.mp3": 1540,
	"./soundBalanceNew.mp3": 1541,
	"./soundConst.mp3": 769,
	"./soundConstNew.mp3": 1542,
	"./soundRest.mp3": 355,
	"./soundRestNew.mp3": 1543,
	"./view5-ex1-slow.mp3": 818,
	"./view8-ex1-slow.mp3": 819,
	"./view9-ex1-slow.mp3": 820
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1520;